import { Component} from '@angular/core';
import { LookupService } from '../service/lookup-filter-service';
import { APISCockpit } from '../service/apis-cockpit';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    providers: [LookupService, APISCockpit],
    standalone: false
})
export class AppComponent { }
